import { type FC } from 'react'

import { useOpenableControls } from '../../../../../../generic-hooks'
import { IconCircleInfoFilled } from '../../../../../../icons'
import { ProductPrescriptionDialog } from '../../../../../../product'
import { ProductHeadGenericLabel } from '../../ProductHeadGenericLabel/ProductHeadGenericLabel'
import { type ProductHeadLabel } from '../../useProductHeadLabels'

export const ProductHeadPrescriptionRequiredLabel: FC<{
  label: ProductHeadLabel
}> = ({ label }) => {
  const modalControls = useOpenableControls()

  return (
    <div>
      <ProductHeadGenericLabel
        className="border-dark-brand-medium bg-light-secondary-medium capitalize"
        hasBorder={false}
        onClick={modalControls.handleOpen}
        type="button"
      >
        {label.labelText}
        <IconCircleInfoFilled className="ml-2 size-4" />
      </ProductHeadGenericLabel>
      <ProductPrescriptionDialog
        isOpen={modalControls.isOpen}
        onClose={modalControls.handleClose}
      />
    </div>
  )
}
